import {Http} from '../dimijs/src/lib/sources/http';
import {ICrudFilter, ICrudList, ICrudPagination, ICrudSorting} from '../dimijs/src/lib/sources/source';
import {IVideo} from './types';

export const getVideosSource = (store:any, serialized?: {
    data: ICrudList<any>,
    filter: ICrudFilter<any>[],
    pagination: ICrudPagination,
    sorting?: ICrudSorting<any>[]
  })=>{
  if (serialized) {
    store.videosSource.source.addSerializedState(serialized.data,
      serialized.filter, serialized.pagination, serialized.sorting);
  }
  return store.videosSource as {
    inited: boolean,
    source: Http<IVideo, string>,
    videosSorting: ICrudSorting<IVideo>[],
    videosFilter: ICrudFilter<IVideo>[],
    videosPagination: ICrudPagination,
  };
};
export const initVideosSource = (store:any, initProps)=>{
  store.videosSource = {
    inited: false,
    source: null as any,
    videosSorting: [],
    videosFilter: [],
    videosPagination: {page: 0, countOnPage: 100},
  };
  store.videosSource.source = new Http<IVideo, string>('_id',
    // @ts-ignore
    initProps && initProps.videos ? {
      data: {
        // @ts-ignore
        data: initProps.videos,
      },
      filter: store.videosSource.videosFilter,
      pagination: store.videosSource.videosPagination,
      sorting: store.videosSource.videosSorting,
    } : undefined);
  store.videosSource.source.httpEndPoint = '/api/videos';
}

